<div #appleSignIn id="appleid-signin" data-color="black" data-border="true" data-type="sign in"></div>

<img [src]="'./assets/images/login_with_apple_'+lang+'.png'" class="apple-login-button" (click)="signIn()">